/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
import {GET_MY_PROFILE,EDIT_PROFILE_DETAILS} from "../pages/Profile/graphql"
import {PROFILE_DATA} from "./test-data/profile-data";
import { toast } from "react-hot-toast"


const MODULE_NAME = "ProfileService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ProfileService {
    private static instance: ProfileService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ProfileService {
        if (!ProfileService.instance) {
            ProfileService.instance = new ProfileService(props);
        }
        return ProfileService.instance;
    }



    async editProfile(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT Profile Details  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_PROFILE_DETAILS,
                    variables: {
                        data: {
                            familyName: data.familyName,
                            givenName: data.givenName,
                            telephone: data.telephone,
                            profileImage: data.profileImage
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT Profile data: ", res);
                if (res) {
                    return res?.data?.editUserProfile;
                }
            }
        } catch (err: any) {
            console.log(err);
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }



    getMeta = (data: any) => {
        if (data) {
            let _output: any = [];

            for (const [key, value] of Object.entries(data)) {
                if (
                    key === "email" ||
                    key === "telephone"
                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                    });
                } else if (key === "sameAs") {
                    _output.push({
                        key: humanize("website"),
                        value: value ? value : "-",
                    });
                }
            }

            return _output;
        }
    };

    getButtons() {
            return [
                {
                    key: "editProfile",
                    title: "Edit",
                },
            ]
        }


    async getProfile() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('graphql-gateway');
        try {
            if (client) {
                // return PROFILE_DATA
                const res = await client.query({
                    query: GET_MY_PROFILE,
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getProfile: ", res);
                return {
                    userData: res?.data?.getUserProfile,
                    paymentOption: res?.data?.getUserProfile?.paymentOption,
                    img: PROFILE_DATA?.img,
                    title: res?.data?.getUserProfile?.fullName,
                    meta: this.getMeta(res?.data?.getUserProfile),
                    buttons: this.getButtons()
                };
            }

        } catch (err) {
            console.log(`error in getProfile=>`, err);
        }
    }
}
